import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, InjectionToken, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTE } from '@bizflex/data-access';
import { catchError, Observable, throwError } from 'rxjs';
import { LoadingService } from '@portal/loading/data-access';
import { HttpStatusCode, SKIP_ERROR_PAGE_INTERCEPTOR } from '@core/data-access';

export const ERROR_PAGE_CODE_EXCLUDE = new InjectionToken<HttpStatusCode[]>('ERROR_PAGE_CODE_EXCLUDE');

@Injectable()
export class ErrorPageInterceptor implements HttpInterceptor {
  private readonly codeExclude = inject(ERROR_PAGE_CODE_EXCLUDE, { optional: true });
  private readonly loadingService = inject(LoadingService);
  private readonly router = inject(Router);
  private readonly ngZone = inject(NgZone);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const statusCodeExclude = this.codeExclude ?? [];

        if (
          request.headers.get(SKIP_ERROR_PAGE_INTERCEPTOR) === 'true' ||
          (statusCodeExclude && statusCodeExclude.find(code => Number(code) === error.status))
        ) {
          return throwError(() => error);
        }

        this.ngZone.run(() => {
          let route: string[] = [];

          switch (error.status) {
            case HttpStatusCode.C401:
            case HttpStatusCode.C403:
              route = [ROUTE.ERROR.MAIN, ROUTE.ERROR.FORBIDDEN];
              break;
            case HttpStatusCode.C404:
              route = [ROUTE.ERROR.MAIN, ROUTE.ERROR.NOT_FOUND];
              break;
            default:
              route = [ROUTE.ERROR.MAIN];
          }

          this.router.navigate(route, { skipLocationChange: true }).then(() => this.loadingService.hide());
        });

        return throwError(() => error);
      }),
    );
  }
}
